var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.stamp
    ? _c("div", { staticClass: "col-md-8 my-10" }, [
        _c("div", { staticClass: "d-flex align-items-center gap-5" }, [
          _c("label", { staticClass: "mb-0" }, [
            _vm._v(" Background color (If background image is not present) "),
          ]),
          _c("div", { staticClass: "color-picker" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.color,
                  expression: "color",
                },
              ],
              attrs: {
                type: "text",
                disabled: _vm.disabled,
                name: "background_color",
              },
              domProps: { value: _vm.color },
              on: {
                change: function ($event) {
                  return _vm.update($event, "color")
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.color = $event.target.value
                },
              },
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.color,
                  expression: "color",
                },
              ],
              attrs: {
                type: "color",
                disabled: _vm.disabled,
                name: "background_color",
              },
              domProps: { value: _vm.color },
              on: {
                change: function ($event) {
                  return _vm.update($event, "color")
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.color = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }